var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6333_10816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9916 13V7C10.9916 6.45 11.4416 6 11.9916 6C12.5416 6 12.9916 6.45 12.9916 7V13C12.9916 13.55 12.5416 14 11.9916 14C11.4416 14 10.9916 13.55 10.9916 13ZM11.9916 15C11.1616 15 10.4916 15.67 10.4916 16.5C10.4916 17.33 11.1616 18 11.9916 18C12.8216 18 13.4916 17.33 13.4916 16.5C13.4916 15.67 12.8216 15 11.9916 15ZM23.5716 19.88C22.8716 21.23 21.4016 22 19.5616 22H4.4316C2.5816 22 1.1216 21.23 0.421603 19.88C-0.288397 18.52 -0.0883965 16.78 0.921603 15.32L8.9616 2.6C9.6716 1.58 10.7916 1 11.9916 1C13.1916 1 14.3116 1.58 14.9916 2.57L23.0716 15.34C24.0816 16.8 24.2716 18.53 23.5616 19.88H23.5716ZM21.4216 16.46C21.4216 16.46 21.4016 16.44 21.4016 16.42L13.3316 3.67C13.0416 3.26 12.5416 3 11.9916 3C11.4416 3 10.9416 3.26 10.6316 3.71L2.5816 16.42C1.9616 17.3 1.8216 18.26 2.1816 18.95C2.5316 19.63 3.3316 20 4.4216 20H19.5416C20.6316 20 21.4316 19.63 21.7816 18.95C22.1416 18.26 22.0016 17.3 21.4116 16.46H21.4216Z",
    fill: "#FF7D81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6333_10816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9867,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast-error.aade9b266b1b4c795a30fac87c05401b.svg";
export { ForwardRef as ReactComponent };